import { Environments } from '@/config';
import { HELIX_HEALTH_PARTNERS_PRODUCTION } from './helix-health-partners.production';
import { HELIX_HEALTH_PARTNERS_STAGING } from './helix-health-partners.staging';

export const HELIX_HEALTH_PARTNERS =
  import.meta.env.MODE === Environments.PROD ? HELIX_HEALTH_PARTNERS_PRODUCTION : HELIX_HEALTH_PARTNERS_STAGING;
